const CurrencyComponent = () => import('@/views/finance/Currency/CurrencyView')

export default [
    {
        path:'/CurrencyIndex',
        name:'CurrencyComponent',
        component:CurrencyComponent
    }
]